import { render, unmountComponentAtNode } from 'react-dom';
import videojs from 'videojs-mux-kit';
import createUsageTracker from './tracker';
import StaticToggle from '../components/StaticToggle';
import { parseQueryParams } from 'video-embed/utils/url';
import { jsx as _jsx } from "react/jsx-runtime";
const VideoJSComponent = videojs.getComponent('Component');
class AutoplayToggle extends VideoJSComponent {
  constructor(player, options) {
    super(player, options);
    this.onToggle = () => {
      this.player().trigger('autoplaytoggle');
      this.tracker.track('playerInteraction', {
        action: 'autoplay-toggle'
      });
    };
    this.checkIfTrue = value => {
      return value === 'true' || value === '1';
    };
    this.mount = () => {
      const autoplay = parseQueryParams(window.location.search).autoplay;
      const autoPlay = parseQueryParams(window.location.search).autoPlay;
      const initialOn = this.checkIfTrue(autoplay) || this.checkIfTrue(autoPlay);
      render( /*#__PURE__*/_jsx(StaticToggle, {
        onToggle: this.onToggle,
        initialOn: initialOn
      }), this.el());
    };
    this.el().className = this.buildCSSClass();
    this.tracker = createUsageTracker(); // defer call until plugin setup to ensure start.ts has already called createUsageTracker with initial props

    player.ready(() => {
      this.mount();
    });
    this.on('dispose', () => {
      unmountComponentAtNode(this.el());
    });
  }
  buildCSSClass() {
    return `vjs-control vjs-playback-options ${super.buildCSSClass()}`;
  }
}
VideoJSComponent.registerComponent('AutoplayToggle', AutoplayToggle);